import React, { useEffect, useState } from "react";
import CustomRow from "../../shared/costum-row/costum-row";

import "./styles.scss";
import useBreakpoints from "../../hooks/use-breakpoints";
import { BREAKPOINTS } from "../../constants/styles";
import HeaderMobile from "./compoents/header-mobile";
import HeaderDesktop from "./compoents/header-desktop";
import { useLocation } from "react-router-dom";
const Header = () => {
  const currentBreakpoint = useBreakpoints();
  const isTablet = currentBreakpoint === BREAKPOINTS.TABLET.type;
  const isMobile = currentBreakpoint === BREAKPOINTS.MOBILE.type;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  let Header = null;
  if (isTablet || isMobile) {
    Header = <HeaderMobile isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />;
  } else {
    Header = <HeaderDesktop />;
  }

  return (
    <>
      <div style={{ width: "100%", height: "102px" }} />
      <CustomRow
        className={`Header ${isMenuOpen ? "active" : ""}`}
        justify="space-between"
      >
        {Header}
      </CustomRow>
    </>
  );
};

export default Header;
